interface BasilicaLogoProps {
	className?: string;
	size?: number;
}

export function BasilicaLogo({ className, size = 16 }: BasilicaLogoProps) {
	const fillColor = "currentColor";

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 160 160"
			fill="none"
			className={className}
			aria-hidden="true"
		>
			<rect x="40" y="20" width="80" height="10" fill={fillColor} />
			<rect x="55" y="30" width="50" height="10" fill={fillColor} />
			<rect
				x="89.999"
				y="9.99998"
				width="9.99996"
				height="10"
				fill={fillColor}
			/>
			<rect x="40" y="9.99998" width="9.99996" height="10" fill={fillColor} />
			<rect x="40" width="19.9999" height="10" fill={fillColor} />
			<rect x="100" width="19.9999" height="10" fill={fillColor} />
			<rect x="100" y="9.99998" width="9.99996" height="10" fill={fillColor} />
			<rect x="50" y="9.99998" width="9.99996" height="10" fill={fillColor} />
			<rect
				x="109.999"
				y="9.99998"
				width="9.99996"
				height="10"
				fill={fillColor}
			/>
			<rect x="60" y="9.99998" width="9.99996" height="10" fill={fillColor} />
			<rect
				width="80"
				height="10"
				transform="matrix(1 0 0 -1 40 140)"
				fill={fillColor}
			/>
			<rect
				width="50"
				height="10"
				transform="matrix(1 0 0 -1 55 130)"
				fill={fillColor}
			/>
			<rect
				width="9.99996"
				height="10"
				transform="matrix(1 0 0 -1 89.999 150)"
				fill={fillColor}
			/>
			<rect
				width="9.99996"
				height="10"
				transform="matrix(1 0 0 -1 40 150)"
				fill={fillColor}
			/>
			<rect
				width="19.9999"
				height="10"
				transform="matrix(1 0 0 -1 40 160)"
				fill={fillColor}
			/>
			<rect
				width="19.9999"
				height="10"
				transform="matrix(1 0 0 -1 100 160)"
				fill={fillColor}
			/>
			<rect
				width="9.99996"
				height="10"
				transform="matrix(1 0 0 -1 100 150)"
				fill={fillColor}
			/>
			<rect
				width="9.99996"
				height="10"
				transform="matrix(1 0 0 -1 50 150)"
				fill={fillColor}
			/>
			<rect
				width="9.99996"
				height="10"
				transform="matrix(1 0 0 -1 109.999 150)"
				fill={fillColor}
			/>
			<rect
				width="9.99996"
				height="10"
				transform="matrix(1 0 0 -1 60 150)"
				fill={fillColor}
			/>
			<rect
				width="80"
				height="10"
				transform="matrix(-4.37114e-08 1 1 4.37114e-08 20 40)"
				fill={fillColor}
			/>
			<rect
				width="50"
				height="10"
				transform="matrix(-6.99382e-08 1 1 2.73196e-08 30 55)"
				fill={fillColor}
			/>
			<rect
				width="10"
				height="9.99992"
				transform="matrix(-4.37114e-08 1 1 4.37114e-08 10.001 90)"
				fill={fillColor}
			/>
			<rect
				width="10"
				height="9.99992"
				transform="matrix(-4.37114e-08 1 1 4.37114e-08 10.001 40)"
				fill={fillColor}
			/>
			<rect
				width="20"
				height="9.99992"
				transform="matrix(-4.37114e-08 1 1 4.37114e-08 0 40)"
				fill={fillColor}
			/>
			<rect
				width="20"
				height="9.99992"
				transform="matrix(-4.37114e-08 1 1 4.37114e-08 0 99.9999)"
				fill={fillColor}
			/>
			<rect
				width="10"
				height="9.99992"
				transform="matrix(-4.37114e-08 1 1 4.37114e-08 10.001 100)"
				fill={fillColor}
			/>
			<rect
				width="10"
				height="9.99992"
				transform="matrix(-4.37114e-08 1 1 4.37114e-08 10.001 50)"
				fill={fillColor}
			/>
			<rect
				width="10"
				height="9.99992"
				transform="matrix(-4.37114e-08 1 1 4.37114e-08 10.001 110)"
				fill={fillColor}
			/>
			<rect
				width="10"
				height="9.99992"
				transform="matrix(-4.37114e-08 1 1 4.37114e-08 10.001 59.9999)"
				fill={fillColor}
			/>
			<rect
				x="140"
				y="40"
				width="80"
				height="10"
				transform="rotate(90 140 40)"
				fill={fillColor}
			/>
			<rect
				x="130"
				y="55"
				width="50"
				height="10"
				transform="rotate(90 130 55)"
				fill={fillColor}
			/>
			<rect
				x="149.999"
				y="90"
				width="10"
				height="9.99992"
				transform="rotate(90 149.999 90)"
				fill={fillColor}
			/>
			<rect
				x="149.999"
				y="40"
				width="10"
				height="9.99992"
				transform="rotate(90 149.999 40)"
				fill={fillColor}
			/>
			<rect
				x="160"
				y="40"
				width="20"
				height="9.99992"
				transform="rotate(90 160 40)"
				fill={fillColor}
			/>
			<rect
				x="160"
				y="100"
				width="20"
				height="9.99992"
				transform="rotate(90 160 100)"
				fill={fillColor}
			/>
			<rect
				x="149.999"
				y="100"
				width="10"
				height="9.99992"
				transform="rotate(90 149.999 100)"
				fill={fillColor}
			/>
			<rect
				x="149.999"
				y="50"
				width="10"
				height="9.99992"
				transform="rotate(90 149.999 50)"
				fill={fillColor}
			/>
			<rect
				x="149.999"
				y="110"
				width="10"
				height="9.99992"
				transform="rotate(90 149.999 110)"
				fill={fillColor}
			/>
			<rect
				x="149.999"
				y="59.9999"
				width="10"
				height="9.99992"
				transform="rotate(90 149.999 59.9999)"
				fill={fillColor}
			/>
		</svg>
	);
}
